import { SelectMark } from '@syconium/little-miss-figgy'

import { useTranslation } from '../../../../../../../app/_providers/TranslationProvider.client'
import { FilterList } from '../../../../../../../components/atoms/FilterList'
import { useHeapAttributes } from '../../../../../../../containers/HeapAttributesContainer'
import { trackEvent } from '../../../../../../../lib/analytics'
import { ProductFilter } from '../../../../../../../types/graphql'
import { useCollectionFiltersContext } from '../containers/CollectionFiltersContext'

import { FilterInputSegment } from './FilterInputSegment'
import {
  Actions,
  ActionsWrap,
  ApplyButton,
  Body,
  CloseWrap,
  FilterBody,
  FilterInputWrap,
  Headline,
  ResetButton,
  TopActions,
  TopBar,
} from './styles'

export const FilterModalContent: React.FC<{
  clearAllFilters: () => void
  closeFilterModal: () => void
  filters: ProductFilter[] | undefined
  isModalDirty: boolean
  selectedFilters: Record<string, string[]>
  totalNumberOfSelectedFilterValues: number
}> = ({ clearAllFilters, closeFilterModal, filters, selectedFilters }) => {
  const {
    collections: {
      filtering: { filterModal: strings },
    },
  } = useTranslation()
  const analyticsContext = useHeapAttributes()
  const category = `${analyticsContext.category ?? 'Unknown'} filters`
  const defaultExpanded = ['color', 'size']
  const { totalItemsCount } = useCollectionFiltersContext()

  return (
    <Body>
      <FilterBody>
        <TopBar>
          <TopActions>
            <Headline asTag='h4' isUppercase={true}>
              {strings.headline}
            </Headline>
            <CloseWrap
              {...trackEvent({
                action: 'click',
                category,
                label: 'close',
              })}
              onClick={closeFilterModal}
            >
              <SelectMark />
            </CloseWrap>
          </TopActions>
        </TopBar>

        {filters?.map(filter => (
          <FilterInputSegment
            filterCount={filter.filterValues?.length ?? 0}
            key={filter.key}
            label={filter.displayName}
            isExpandedInitially={defaultExpanded.includes(filter.key)}
            selectedFilterCount={
              selectedFilters[filter.key]?.length ??
              filter.filterValues?.filter(o => o.state === 'SELECTED').length ??
              0
            }
          >
            <FilterInputWrap>
              <FilterList.List count={filter.filterValues?.length ?? 0}>
                {filter.filterValues?.map(filterValue =>
                  filter.displayType === 'basicColor' ? (
                    <FilterList.ColorItem
                      key={filterValue.value}
                      filterKey={filter.key}
                      filterValue={filterValue}
                      asLink={filter.crawlable}
                    />
                  ) : (
                    <FilterList.CheckboxItem
                      key={filterValue.value}
                      filterKey={filter.key}
                      filterValue={filterValue}
                      asLink={filter.crawlable}
                    />
                  )
                )}
              </FilterList.List>
            </FilterInputWrap>
          </FilterInputSegment>
        ))}
      </FilterBody>
      <ActionsWrap>
        <Actions>
          <ResetButton
            {...trackEvent({
              action: 'click',
              category,
              label: strings.clearAllFiltersCta,
            })}
            onClick={clearAllFilters}
            variant='ghost'
          >
            {strings.clearAllFiltersCta}
          </ResetButton>
          <ApplyButton
            {...trackEvent({
              action: 'click',
              category,
              label: strings.applyFiltersCta,
            })}
            onClick={closeFilterModal}
            disabled={totalItemsCount === 0}
          >
            {totalItemsCount && totalItemsCount > 0
              ? `${strings.viewCtaPrefix} ${totalItemsCount}`
              : totalItemsCount === 0
              ? 0
              : `${strings.viewCtaPrefix} ${strings.ellipsis}`}{' '}
            {strings.viewCtaPostfix}
          </ApplyButton>
        </Actions>
      </ActionsWrap>
    </Body>
  )
}
